import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';

import spinnerGradient from './spinner-gradient.svg';
import spinnerWhite from './spinner-white.svg';
import { DEFAULT_SIZE, DEFAULT_COLOR } from './Loader.const';

const styles = {
  '@keyframes loop': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  spinner: {
    position: 'relative',
    animation: '$loop 1.1s infinite linear',
    backgroundRepeat: 'no-repeat',
  },
  wrapper: {
    maxHeight: '75px',
  },
};

class Loader extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    size: PropTypes.number,
    color: PropTypes.string,
  };

  static defaultProps = {
    size: DEFAULT_SIZE,
    color: DEFAULT_COLOR,
  };

  render() {
    const { classes, color, size, ...rest } = this.props;

    const spinnerColor = color === DEFAULT_COLOR ? `url(${spinnerGradient})` : `url(${spinnerWhite})`;

    return (
      <div data-testid={rest['data-testid']} className={classes.wrapper}>
        <div className={classes.spinner} style={{ background: spinnerColor, width: size, height: size }} />
      </div>
    );
  }
}

export default injectStyles(styles)(Loader);
